import { Button } from "imagine-ui";

interface Props {
  to: string;
  text: string;
  className?: string;
}

export const NavigateBack = (props: Props) => {
  return (
    <Button
      icon="chevron-left"
      outline
      className={props.className}
      iconSize="xs"
      size="sm"
      to={props.to}
    >
      {props.text}
    </Button>
  );
};
